import { OrderedListOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Modal, Row, Space, notification } from 'antd';
import React, { useState } from 'react';
import { alterarBlacklist } from '../../../blackList/services/updateBlackList';
import { IMotorista } from '../../../../../store/ducks/motorista/types';
import { ApplicationState } from '../../../../../store';
import { loadRequest } from '../../../../../store/ducks/motorista/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ROLE } from '../../../../../utils/roles';
interface Props {
  record: IMotorista;
}

const App: React.FC<Props> = ({ record }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = (values: any) => {
    try {
      const isAtivo = false;
      alterarBlacklist
        .alterarBlacklist(isAtivo, values?.observacao, record?.codMotorista)
        .then((res) => {
          notification.success({
            message: `Motorista inserido na block list com sucesso!`,
            placement: 'bottomRight',
          });

          setIsModalOpen(false);
          dispatch(loadRequest(inscricaoAtiva));
          form.resetFields();
        });
    } catch (error: any) {
      if (error.response.data.Erro) {
        return notification.error({
          message: error.response.data.Erro,
          placement: 'bottomRight',
        });
      }
      return notification.error({
        message: `Não foi possível adicionar o motorista, tente novamente ou contate o suporte.`,
        placement: 'bottomRight',
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  return (
    <>
      {(ROLE.ADMINISTRADOR || ROLE.ANALISTACD) && (
        <Button icon={<OrderedListOutlined />} onClick={showModal}>
          {' '}
          <i>Block list</i>
        </Button>
      )}
      <Modal title={<i>Block list</i>} visible={isModalOpen} footer={null}>
        <Form layout="vertical" name="motoristas" onFinish={handleOk} form={form}>
          <Form.Item
            label="Observação"
            name="observacao"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>

          <Row gutter={24}>
            <Col md={24} sm={24} xs={24} style={{ textAlign: 'end' }}>
              <Space>
                <Button type="default" onClick={handleCancel}>
                  Cancelar
                </Button>

                <Button type="primary" htmlType="submit">
                  Adicionar
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default App;
